import { useCoinsFeature } from '@common/hooks/featureToggles';
import { useSiteCountryCode } from '@common/hooks/localisation';
import { useRedirect } from '@common/hooks/useRedirect';

export const useRedirectIfCoinsDisabled = () => {
  const { redirect } = useRedirect();
  const countryCode = useSiteCountryCode();
  const isCoinsEnabled = useCoinsFeature(countryCode);

  if (!isCoinsEnabled) {
    redirect(`/${countryCode}/`)();
  }
};
